import { type FlowAgentMetricRequest, type FlowMetricRequest } from 'flow-schema';

import { BaseAPI } from '../common.js';
import {
  type AnalyticalFlowMetricResponse,
  type RealtimeAgentMetricResponse,
} from '../models/flow/metric.js';

export class API extends BaseAPI {
  baseEndpoint = 'flow/metrics';

  // Analytical metrics (Source: BigQuery)
  async getAnalyticalFlowMetrics(
    request: FlowMetricRequest
  ): Promise<AnalyticalFlowMetricResponse> {
    const url = this.common.constructPath(`${this.baseEndpoint}/analytical/flows`);
    return await this.common.postJSON(url, request);
  }

  async getAnalyticalAgentMetrics(
    request: FlowAgentMetricRequest
  ): Promise<AnalyticalFlowMetricResponse> {
    const url = this.common.constructPath(`${this.baseEndpoint}/analytical/agents`);
    return await this.common.postJSON(url, request);
  }

  // Realtime metrics (Source: PostgreSQL)
  async getRealtimeAgentMetrics(
    request: FlowAgentMetricRequest
  ): Promise<RealtimeAgentMetricResponse> {
    const url = this.common.constructPath(`${this.baseEndpoint}/realtime/agents`);
    return await this.common.postJSON(url, request);
  }
}
